import type { Editor } from '@tiptap/react';
import { type Event, type EventFn, TeaPubSub } from './tea-pub-sub.ts';

export class TeaListener {
  initSubscriber;
  editor: Editor | undefined;

  constructor(public id: string) {
    this.id = id;

    this.initSubscriber = this.on('editor-updated', ({ editor }) => {
      this.editor = editor;
    });

    this.forceEditorStateUpdate();
  }

  on(event: Event, fn: EventFn) {
    const subscriber = TeaPubSub.instance.subscribe(event, this.id, fn);

    return {
      id: subscriber.id,
      unsubscribe: () => TeaPubSub.instance.unsubscribe(event, subscriber.id),
    };
  }

  forceEditorStateUpdate() {
    TeaPubSub.instance.publish('listener-created', { id: this.id });
  }
}
